export default __webpack_public_path__ + "static/media/business-building.457a353a.png";